import * as React from "react";
import { makeStyles, Button, shorthands } from "@fluentui/react-components";
import PropTypes from 'prop-types';

const useStyles = makeStyles({
  root: {
    ...shorthands.border("1px", "solid", "#d1d1d1"),
    ...shorthands.borderRadius("4px"),
  },
});

export const FluentButton = ({
  id,
  icon,
  appearance = "outline",
  text,
  onClick,
  disabled,
  className,
}) => {
  const styles = useStyles();

  return (
    <div className={appearance === "outline" || appearance === "secondaryWithOutline"? styles.root : undefined}>
      <Button
        id={id}
        icon={icon}
        appearance={appearance === "secondaryWithOutline" ? "secondary" : appearance}
        disabledFocusable={disabled}
        onClick={onClick}
        className={className}
      >
        {text}
      </Button>
    </div>
  );
};

FluentButton.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.node,
  appearance: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};